import "./Header.css";
import useStore from "../../store";

import MaterialIcon from "../MaterialIcon/MaterialIcon";

import { useNavigateWithVars } from "../../hooks/useNavigateWithVars";
import { useParams } from "react-router-dom";
import HintButton from "../HintButton/HintButton";
const Header = () => {
  const navigateTo = useNavigateWithVars();

  const { roundid } = useParams();
  const getLocalized = useStore((state) => state.getLocalized);
  const gameState = useStore((state) => state.gameState);
  const game = useStore((state) => state.game);
  const currentHint = useStore((state) => state.currentHint);
  const toggleMenu = useStore((state) => state.toggleMenu);
  const menuOpen = useStore((state) => state.menuOpen);

  const roundItems = Array.from(
    { length: game?.Rounds },
    (_, index) => index + 1,
  );

  return (
    <header className="Header">
      <MaterialIcon
        name={menuOpen ? "close" : "menu"}
        className="menuIcon"
        onClick={toggleMenu}
      />
      {gameState > 0 && (
        <div className="rounds">
          {getLocalized("texts", "Runde")}:
          {roundItems.map((round) => (
            <span
              key={round}
              className={`${
                gameState === round
                  ? "current"
                  : gameState < round
                    ? "disabled"
                    : ""
              }${roundid === round ? " active" : ""}`}
              onClick={() =>
                gameState >= round ? navigateTo("/round/" + round) : null
              }
            >
              {round}
            </span>
          ))}
        </div>
      )}

      {currentHint > -1 && <HintButton />}
    </header>
  );
};

export default Header;
